export default "__VITE_ASSET__DPVxpiKW__"